import { useState, useEffect } from 'react';

export const useGeoLocation = () => {
  const [locationInfo, setLocationInfo]     = useState(null);
  const [locationError, setLocationError]   = useState(null);
  

  useEffect(() => {
    if (!locationError && !locationInfo) {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => setLocationInfo(coords),
        (err)       => setLocationError(err.message)
      );
    }
  }, [locationInfo, locationError]);

  return { locationInfo, locationError };
};